/**
 * Visual Complexity Logic
 * Calculates a complexity score [0, 1] for visual rendering based on reasoning chains.
 */

export function calculateReasoningComplexity(reasoning?: string): number {
  if (!reasoning) return 0
  
  let complexity = Math.min(reasoning.length / 2000, 0.6)
  
  // Look for step-by-step markers
  if (/step\s*\d+|step\s*[ivx]+/i.test(reasoning)) complexity += 0.15
  
  // Keyword density for analytical depth
  if (/\b(analyze|consider|evaluate|assess|examine|investigate)\b/i.test(reasoning)) complexity += 0.1
  
  // Logical progression markers
  if (/\b(therefore|thus|consequently|hence|because|since)\b/i.test(reasoning)) complexity += 0.1
  
  // Uncertainty/Question density
  if ((reasoning.match(/\?/g) || []).length > 1) complexity += 0.05
  
  return Math.min(complexity, 1)
}
